var PassageTile = require("components/cloze/PassageTile.js")

require('cloze/category_picker.scss')
class CategoryPicker extends React.Component {
	constructor(props) {
		super();

		if (props.forcePassageType) {
			var defaultType = props.forcePassageType
		} else if (props.selectedCategory) {
			// If we started off with a category, use that passageType
			var defaultType = props.selectedCategory.passageType;
		} else {
			// Randomize the default passageType
			var defaultType = _.sample([CategoryPicker.FICTION, CategoryPicker.NON_FICTION]);			
		}

		this.state = { passageType: defaultType };
	}

	onCategorySelect(category, e) {
		if (e) { e.preventDefault(); }
		this.props.onCategorySelect(category);
	}

	onPassageTypeSelect(passageType, e) {
		if (e) { e.preventDefault(); }
		if (passageType == this.state.passageType) { return; }

		this.setState({ passageType: passageType });

		if (this.props.selectedCategory) {
			// Most categories have both fiction and nonFiction options. However, some don't.
			// Just in case, if there isn't, we want to set the selected category to null
			var matches = this.matchingCategories(passageType, 
				this.props.selectedCategory.categoryName);

			if (matches.length == 0) {
				this.onCategorySelect(null);
			} else {
				this.onCategorySelect(matches[0]);
			}
		}
	}

	onPassageSelect(passage, e) {
		if (e) { e.preventDefault(); }
		this.props.onPassageSelect(passage);
	}

	matchingCategories(passageType, categoryName) {
		var categories = _.where(this.props.categories, { "passageType": passageType });
		if (categoryName) {
			categories = _.where(categories, { "categoryName": categoryName });
		}
		return categories;
	}

	render() {
		var categories = _.sortBy(this.matchingCategories(this.state.passageType), "categoryName");
		var selectedCategory = this.props.selectedCategory;
		var categoryOptions = _.map(categories, (category) => {
			var key = category.categoryName + "-" + category.passageType;
			var catClassName = "bubbleOp";

			if (selectedCategory && (selectedCategory.categoryName == category.categoryName)) {
				catClassName += " active";
			}
			if (this.props.getIcon) {
				var icon = (
					<img src={ this.props.getIcon(category.categoryName) } className="icon" />
				);
			}
			return (
				<a href="#" key={ key } className={ catClassName }
					onClick={ this.onCategorySelect.bind(this, category) }>
					{ icon }{ category.categoryName }
				</a>
			)
		});

		if (this.props.passages && this.props.passages.length > 0) {
			var passageOptions = _.map(this.props.passages, (passage) => {
				return (
					<PassageTile key={ passage.passageId } title={ passage.title }
						subCategoryName={ passage.subCategory } getIcon={ this.props.getIcon }						
						onClick={ this.onPassageSelect.bind(this, passage) }
						categoryName={ selectedCategory.categoryName } />
				);
			});

			var passageOptionSection = (
				<div className="passageOptions">
					{ passageOptions }
				</div>
			);

		} else if (this.props.passages && this.props.passages.length == 0) {
			var passageOptionSection = (
				<div className="passageOptions">
					<div className="passageMessage">
						There aren't any options for this category! Please pick a different one.
					</div>
				</div>
			)


		} else if (selectedCategory) {
			if (this.props.loadingIndicator) {
				var passageOptionSection = (
					<div className="passageOptions">
						<div className="passageMessage">
							{ this.props.loadingIndicator }
						</div>
					</div>
				)			
			} else {
				var passageOptionSection = (
					<div className="passageOptions">
						<div className="passageMessage">
							Loading passages...
						</div>
					</div>
				)

			}
		}

		if (!this.props.forcePassageType) {
			var isFiction = this.state.passageType == CategoryPicker.FICTION;

			var passageTypePicker = (
				<div className="passageTypeOptions">
					<a href="#" className={ isFiction ? "bubbleOp active" : "bubbleOp" }
						onClick={ this.onPassageTypeSelect.bind(this, CategoryPicker.FICTION) }>
						Fiction
					</a>
					<a href="#" className={ isFiction ? "bubbleOp" : "bubbleOp active" }
						onClick={ this.onPassageTypeSelect.bind(this, CategoryPicker.NON_FICTION) }>
						Non-Fiction
					</a>
				</div>
			);
		}

		return (
			<div className="Cloze-CategoryPicker">
				{ passageTypePicker }
				<div className="categoryOptions">
					{ categoryOptions }
				</div>
				{ passageOptionSection }
			</div>
		);
	}
}

CategoryPicker.FICTION = "Fiction";
CategoryPicker.NON_FICTION = "NonFiction";

CategoryPicker.propTypes = {
	categories: PropTypes.array.isRequired,
	onCategorySelect: PropTypes.func.isRequired,
	onPassageSelect: PropTypes.func.isRequired,
	selectedCategory: PropTypes.object,
	passages: PropTypes.array,
	getIcon: PropTypes.func,
	loadingIndicator: PropTypes.PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),

	forcePassageType: PropTypes.string

}

module.exports = CategoryPicker


// WEBPACK FOOTER //
// ./modules/components/cloze/CategoryPicker.js